module.exports = __webpack_public_path__ + "img/menu.6c25afd4.svg";